<template>
    <modal
        :id="modalId"
        title="Delete Lock"
        @ok="handleDeleteLock"
    >
        <b-row>
            <b-col>
                Lock "{{ name }}" and all its access codes will be deleted from Lodgix.
            </b-col>
        </b-row>
        <br />
        <b-row>
            <b-col>
                <form-select
                    label="Also delete lock from LockState?"
                    v-model="values.delete_lockstate_lock"
                    :options="deleteLockOptions"
                ></form-select>
            </b-col>
        </b-row>
    </modal>
</template>

<script>
    import Modal from '../../../../generic/modal/modal.vue';
    import FormSelect from '../../../../generic/form-select/form-select.vue';

    export default {
        components: {
            Modal,
            FormSelect,
        },
        props: {
            modalId: String,
            name: String,
        },
        data() {
            return {
                deleteLockOptions: [
                    { value: false, text: 'No' },
                    { value: true, text: 'Yes' },
                ],
                values: {
                    delete_lockstate_lock: false,
                }
            }
        },
        methods: {
            handleDeleteLock() {
                this.$emit('delete', this.values);
            },
        } 
    }
</script>
